import React from 'react'
import './Home.css'

function Home() {
    return (
        <div className='home'>
            Quizzer
        </div>
    )
}

export default Home;
